import React, { useState, useEffect } from 'react';
import { ArrowRight } from "phosphor-react";
import prakartiimg from "../assets/images/prakarti-img.png";
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MdMailOutline } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";



function Footer() {
    const [visitorCount, setVisitorCount] = useState(null);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    // Fetch the visitor count when the component mounts
    useEffect(() => {
        // Check if we are on the homepage (i.e., "/")
        const isHomepage = window.location.pathname === '/';
    
        let storedCount = localStorage.getItem('visitorCount');
    
        // If there's a stored visitor count, use it
        if (storedCount) {
            setVisitorCount(Number(storedCount));
        }
    
        const fetchVisitorCount = async () => {
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/count-visitors', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ action: 'getVisitorCount' }),
                });
                const data = await response.json();
                storedCount = data.data.count;
                localStorage.setItem('visitorCount', storedCount); // Save the updated count in localStorage
                setVisitorCount(storedCount); // Update state with the fetched count
            } catch (error) {
                console.error('Error fetching visitor count:', error);
            }
        };
    
        if (isHomepage) {
            console.log('isHomepage');
            const visited = localStorage.getItem('hasVisitedHomepage');
            const newUserCounter = parseInt(localStorage.getItem('newUserCounter') || '0', 10);
    
            // Only increment on the first visit to the homepage
            if (!visited) {
                // Mark as visited
                localStorage.setItem('hasVisitedHomepage', 'true');
    
                // Increment the count on the server
                fetch('/api/count-visitors', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ action: 'increment' }),
                });
    
                // Update local counter
                const updatedCounter = newUserCounter + 1;
                localStorage.setItem('newUserCounter', updatedCounter.toString());
    
                // Only fetch from server every 100 new users
                if (updatedCounter % 100 === 0) {
                    fetchVisitorCount();
                }
            }
        }
    }, []);
    
    // Empty dependency array to run this effect only once on mount

    return (
        <footer>
            <div className="container">
                <div className="row animate__animated animate__fadeInLeft">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <h2>Publications</h2>
                        <ul>
                        <li><a target="_blank" href="https://ndl.education.gov.in/api/upload/g20/file/G20F1E.pdf"><ArrowRight size={20} /> G20 Symbol of Development </a></li>
                            <li><a target="_blank" href="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Thinking-For-Our-Planet-75-Ideas-to-Promote-LiFE.pdf?sp=r&st=2025-04-07T11:28:24Z&se=2025-06-29T19:28:24Z&spr=https&sv=2024-11-04&sr=c&sig=UtTuVhtLRQnfbAGjsTlB4sFYcG44G5oJj20DM3pz2ZQ%3D"><ArrowRight size={20} /> Thinking For Our Planet 75 Ideas to Promote LiFE</a></li>
                            <li><a target="_blank" href="https://ndl.education.gov.in/api/upload/ACK/files/ACK_A_Greener_Ride_English_MOC.pdf"><ArrowRight size={20} /> A Greener Ride!</a></li>
                            <li><a href="https://ecoclubs.education.gov.in/viewUpload/uploads/books/pcracomics.pdf" target="_blank"><ArrowRight size={20} /> Fuel and Environment Conservation</a></li>
                            <li><a target="_blank" href="https://ndl.education.gov.in/api/upload/g20/file/G20M3E.pdf"><ArrowRight size={20} /> G20 Health and Well-being</a></li>
                        </ul>
                    </div>
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                    <h2>QuickLinks</h2>
                        <ul>
                            <li><Link to="/ras-gallery"><ArrowRight size={20} /> RAS Image Gallery </Link></li>
                            <li><Link to="/image-gallery"><ArrowRight size={20} /> Event Image Gallery </Link></li>
                            <li><Link to="/VideoGallery"><ArrowRight size={20} /> Video Gallery</Link></li>
                            <li><Link to="/ecocalendar"><ArrowRight size={20} /> LiFE Calendar</Link></li>
                            {/* <li><Link to="/Downloads"><ArrowRight size={20} /> Download</Link></li> */}
                            <li><Link to="/HelpManual"><ArrowRight size={20} /> Help Manual</Link></li>
                            <li><Link to="/demo-videos"><ArrowRight size={20} /> Demo Videos</Link></li>
                        </ul>
                       
                    </div>
                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                    <h2>Contact us</h2>
                        <ul className='contactList'>
                            <li><a href='tel:011-29581423'><IoCallOutline /> 011-29581423</a></li>
                            <li><a href='tel:+919773795438'><IoCallOutline /> +91 9773795438</a></li>
                            <li><a href='tel:011-29581423'><IoCallOutline /> +91 7206823720</a></li>
                            <li><span><MdMailOutline /> contact[dot]ecoclubs-edu[at]gov[dot]in</span></li>
                            <li><span><MdMailOutline /> info[dot]ecoclubs-edu[at]gov[dot]in</span></li>
                            <li><span><MdMailOutline /> help[dot]ecoclubs-edu[at]gov[dot]in</span></li>
                           
                       </ul>
                        <div className="text-start text-white">
                            <span className="counterTag">
                                Total Visitors <span className="text-dark">{visitorCount !== null ? visitorCount : "Loading..."}</span>
                            </span>
                        </div>
                        <div className="girls">
                            <Image src={prakartiimg} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottomFoot">
                <ul className="d-flex justify-content-center">
                    <li><a href="#">Privacy Policy |</a></li>
                    <li><a href="#">Terms of Use</a></li>
                </ul>
                {/* <center>©2025 All rights reserved, By Ministry Of Education.Technology Partner@Anuvadini</center> */}
                <center>©2025 All rights reserved By Ministry Of Education. Technology Partner@ <a href="https://anuvadini.aicte-india.org/" target="_blank">Anuvadini</a></center>

            </div>
        </footer>
    );
}

export default Footer;
